import { useTranslate } from "@similarweb/i18n-provider";
import { DotsLoader } from "@similarweb/ui-components";

import {
    StyledFilterSuggestionsBar,
    StyledFilterSuggestionsTitle,
    StyledLoaderWrapper,
    StyledSuggestedChipsContainer,
    StyledSuggestedWrapper,
    StyledSuggestIcon,
} from "./styles";
import type { SuggestedChipItemProps } from "./SuggestedChipItem/SuggestedChipItem";
import { SuggestedChipItem } from "./SuggestedChipItem/SuggestedChipItem";

type SuggestionsBarProps = {
    suggestedItems: readonly SuggestedChipItemProps[];
    isLoading: boolean;
    isEnabled: boolean;
    dataAutomation?: string;
};

const FilterSuggestionsBar = ({ suggestedItems, isEnabled, isLoading, dataAutomation }: SuggestionsBarProps) => {
    const { translate } = useTranslate();

    const hasSuggestions = suggestedItems.length > 0;
    const isVisible = isEnabled && (hasSuggestions || isLoading);

    if (!isVisible) {
        return null;
    }

    return (
        <StyledFilterSuggestionsBar data-automation={dataAutomation}>
            <StyledSuggestedWrapper>
                <StyledSuggestIcon
                    iconName="wand"
                    size="xs"
                />
                <StyledFilterSuggestionsTitle>
                    {translate("si.lead_gen_filters.categoryFilter.suggested")}
                </StyledFilterSuggestionsTitle>
                {isLoading && !hasSuggestions ? (
                    <StyledLoaderWrapper>
                        <DotsLoader />
                    </StyledLoaderWrapper>
                ) : null}
            </StyledSuggestedWrapper>

            {hasSuggestions ? (
                <StyledSuggestedChipsContainer
                    ChipComponent={SuggestedChipItem}
                    items={suggestedItems}
                    isLoading={isLoading}
                />
            ) : null}
        </StyledFilterSuggestionsBar>
    );
};

export default FilterSuggestionsBar;
